"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var memdb_exports = {};
__export(memdb_exports, {
  MemDb: () => MemDb,
  ModelDb: () => ModelDb,
  TxDb: () => TxDb
});
module.exports = __toCommonJS(memdb_exports);
var import_platform = require("@hcengineering/platform");
var import__ = require(".");
var import_clone = require("./clone");
var import_component = __toESM(require("./component"));
var import_query = require("./query");
var import_tx = require("./tx");
var import_utils = require("./utils");
function deepFreeze(value) {
  if (typeof value !== "object" || value === null || Object.isFrozen(value)) return;
  Object.freeze(value);
  for (const key of Object.keys(value)) {
    deepFreeze(value[key]);
  }
}
__name(deepFreeze, "deepFreeze");
class MemDb extends import_tx.TxProcessor {
  /** `parent` is a shared system model; own documents win, the rest is read from it. */
  constructor(hierarchy, parent) {
    super();
    this.hierarchy = hierarchy;
    this.parent = parent;
  }
  static {
    __name(this, "MemDb");
  }
  objectsByClass = /* @__PURE__ */ new Map();
  objectById = /* @__PURE__ */ new Map();
  // Documents of the shared parent this db hides (removed or replaced here).
  shadowed = /* @__PURE__ */ new Set();
  getObjectsByClass(_class) {
    const result = this.objectsByClass.get(_class);
    if (result === void 0) {
      const result2 = /* @__PURE__ */ new Map();
      this.objectsByClass.set(_class, result2);
      return result2;
    }
    return result;
  }
  /** Own documents of a class plus the parent's, minus anything this db shadows. */
  allOfClass(_class) {
    const own = this.objectsByClass.get(_class);
    if (this.parent === void 0) {
      return own === void 0 ? [] : Array.from(own.values());
    }
    if (own === void 0 && this.shadowed.size === 0) {
      return this.parent.allOfClass(_class);
    }
    const result = [];
    for (const doc of this.parent.allOfClass(_class)) {
      if (!this.shadowed.has(doc._id) && own?.has(doc._id) !== true) {
        result.push(doc);
      }
    }
    if (own !== void 0) {
      result.push(...own.values());
    }
    return result;
  }
  findDoc(_id) {
    const own = this.objectById.get(_id);
    if (own !== void 0) return own;
    if (this.shadowed.has(_id)) return void 0;
    return this.parent?.findDoc(_id);
  }
  cleanObjectByClass(_class, _id) {
    const result = this.objectsByClass.get(_class);
    if (result !== void 0) {
      result.delete(_id);
    }
  }
  getByIdQuery(query, _class) {
    const result = [];
    if (typeof query._id === "string") {
      const obj = this.findDoc(query._id);
      if (obj !== void 0 && this.hierarchy.isDerived(obj._class, _class)) result.push(obj);
    } else if (query._id?.$in !== void 0) {
      const ids = new Set(query._id.$in);
      for (const id of ids) {
        const obj = this.findDoc(id);
        if (obj !== void 0 && this.hierarchy.isDerived(obj._class, _class)) result.push(obj);
      }
    }
    return result;
  }
  getObject(_id) {
    const doc = this.findDoc(_id);
    if (doc === void 0) {
      throw new import_platform.PlatformError(new import_platform.Status(import_platform.Severity.ERROR, import_component.default.status.ObjectNotFound, { _id }));
    }
    return doc;
  }
  findObject(_id) {
    const doc = this.findDoc(_id);
    return doc;
  }
  async getLookupValue(_class, doc, lookup, result) {
    for (const key in lookup) {
      if (key === "_id") {
        await this.getReverseLookupValue(doc, lookup, result);
        continue;
      }
      const value = lookup[key];
      const tkey = (0, import_query.checkMixinKey)(key, _class, this.hierarchy);
      const refId = (0, import__.getObjectValue)(tkey, doc);
      if (refId == null) continue;
      if (Array.isArray(value)) {
        const [_class2, nested] = value;
        const objects = await this.findAll(_class2, { _id: refId });
        result[key] = objects[0];
        const nestedResult = {};
        const parent = result[key];
        await this.getLookupValue(_class2, parent, nested, nestedResult);
        Object.assign(parent, {
          $lookup: nestedResult
        });
      } else {
        const objects = await this.findAll(value, { _id: refId });
        result[key] = objects[0];
      }
    }
  }
  async getReverseLookupValue(doc, lookup, result) {
    for (const key in lookup._id) {
      const value = lookup._id[key];
      if (Array.isArray(value)) {
        const objects = await this.findAll(value[0], { [value[1]]: doc._id });
        result[key] = objects;
      } else {
        const objects = await this.findAll(value, { attachedTo: doc._id });
        result[key] = objects;
      }
    }
  }
  async lookup(_class, docs, lookup) {
    const withLookup = [];
    for (const doc of docs) {
      const result = {};
      await this.getLookupValue(_class, doc, lookup, result);
      withLookup.push(Object.assign({}, doc, { $lookup: result }));
    }
    return withLookup;
  }
  async fillAssociations(docs, associations) {
    const withLookup = [];
    for (const doc of docs) {
      const result = await this.getAssociationValue(doc, associations);
      withLookup.push(Object.assign({}, doc, { $associations: result }));
    }
    return withLookup;
  }
  async getAssociationValue(doc, associations) {
    const result = {};
    for (const association of associations) {
      const _id = association[0];
      const assoc = this.findObject(_id);
      if (assoc === void 0) continue;
      const isReverse = association[1] === -1;
      const key = !isReverse ? "docA" : "docB";
      const key2 = !isReverse ? "docB" : "docA";
      const _class = !isReverse ? assoc.classB : assoc.classA;
      const relations = await this.findAll(import_component.default.class.Relation, { association: _id, [key]: doc._id });
      let objects = await this.findAll(_class, { _id: { $in: relations.map((r) => r[key2]) } });
      if (association[2] !== void 0) {
        objects = (0, import_utils.toFindResult)(await this.fillAssociations(objects, association[2]), objects.length);
      }
      result[`${_id}_${!isReverse ? "b" : "a"}`] = objects;
    }
    return result;
  }
  async findAll(_class, query, options) {
    let result;
    const baseClass = this.hierarchy.getBaseClass(_class);
    if (Object.prototype.hasOwnProperty.call(query, "_id") && (typeof query._id === "string" || query._id?.$in !== void 0 || query._id === void 0 || query._id === null)) {
      result = this.getByIdQuery(query, baseClass);
    } else {
      result = this.allOfClass(baseClass);
    }
    result = (0, import_query.matchQuery)(result, query, _class, this.hierarchy, true);
    if (baseClass !== _class) {
      result = result.filter((r) => r[_class] !== void 0);
    }
    if (options?.lookup !== void 0) {
      result = await this.lookup(_class, result, options.lookup);
      result = (0, import_query.matchQuery)(result, query, _class, this.hierarchy);
    }
    if (options?.associations !== void 0) {
      result = await this.fillAssociations(result, options.associations);
    }
    if (options?.sort !== void 0) (0, import_query.resultSort)(result, options?.sort, _class, this.hierarchy, this);
    const total = result.length;
    result = result.slice(0, options?.limit);
    const tresult = this.hierarchy.clone(result);
    const res = tresult.map((it) => this.hierarchy.updateLookupMixin(_class, it, options));
    return (0, import_utils.toFindResult)(res, total);
  }
  async findOne(_class, query, options) {
    return (await this.findAll(_class, query, { ...options, limit: 1 }))[0];
  }
  /**
   * Only in model find without lookups and sorting.
   * Do not clone results, so be aware modifications are not allowed.
   */
  findAllSync(_class, query, options) {
    let result;
    const baseClass = this.hierarchy.getBaseClass(_class);
    if (Object.prototype.hasOwnProperty.call(query, "_id") && (typeof query._id === "string" || query._id?.$in !== void 0 || query._id === void 0 || query._id === null)) {
      result = this.getByIdQuery(query, baseClass);
    } else {
      result = this.allOfClass(baseClass);
    }
    result = (0, import_query.matchQuery)(result, query, _class, this.hierarchy, true);
    if (baseClass !== _class) {
      result = result.filter((r) => r[_class] !== void 0);
    }
    if (options?.sort !== void 0) (0, import_query.resultSort)(result, options?.sort, _class, this.hierarchy, this);
    const total = result.length;
    result = result.slice(0, options?.limit);
    return (0, import_utils.toFindResult)(
      result.map((it) => {
        return baseClass !== _class ? this.hierarchy.as(it, _class) : it;
      }),
      total
    );
  }
  addDoc(doc) {
    this.objectById.set(doc._id, doc);
    this.indexByClass(doc);
  }
  /** Deep freeze every document held now: a direct write into a shared one must not leak. */
  freeze() {
    for (const doc of this.objectById.values()) {
      deepFreeze(doc);
    }
  }
  /** Copy-on-write: a document of the shared parent must be deep copied, never mutated in place. */
  ownDoc(_id) {
    const own = this.objectById.get(_id);
    if (own !== void 0 && !Object.isFrozen(own)) {
      return own;
    }
    if (own !== void 0 && this.parent === void 0) {
      throw new Error(`frozen shared model must not be modified: ${_id}`);
    }
    const doc = own ?? this.findDoc(_id);
    if (doc === void 0) {
      return void 0;
    }
    const copy = (0, import_clone.clone)(doc);
    this.objectById.set(copy._id, copy);
    this.shadowed.add(copy._id);
    for (const _class of this.hierarchy.getAncestors(copy._class)) {
      this.getObjectsByClass(_class).set(copy._id, copy);
    }
    this.hierarchy.replaceDoc(copy);
    return copy;
  }
  indexByClass(doc) {
    this.hierarchy.getAncestors(doc._class).forEach((_class) => {
      const arr = this.getObjectsByClass(_class);
      arr.set(doc._id, doc);
    });
  }
  delDoc(_id) {
    const doc = this.findDoc(_id);
    if (doc === void 0) {
      throw new import_platform.PlatformError(new import_platform.Status(import_platform.Severity.ERROR, import_component.default.status.ObjectNotFound, { _id }));
    }
    this.objectById.delete(_id);
    this.shadowed.add(_id);
    this.hierarchy.getAncestors(doc._class).forEach((_class) => {
      this.cleanObjectByClass(_class, _id);
    });
  }
  updateDoc(_id, doc, update) {
  }
}
class TxDb extends MemDb {
  static {
    __name(this, "TxDb");
  }
  txCreateDoc(tx) {
    throw new Error("Method not implemented.");
  }
  txUpdateDoc(tx) {
    throw new Error("Method not implemented.");
  }
  txRemoveDoc(tx) {
    throw new Error("Method not implemented.");
  }
  txMixin(tx) {
    throw new Error("Method not implemented.");
  }
  async tx(tx) {
    this.addDoc(tx);
    return [];
  }
}
class ModelDb extends MemDb {
  static {
    __name(this, "ModelDb");
  }
  async txCreateDoc(tx) {
    this.addDoc(import_tx.TxProcessor.createDoc2Doc(tx));
    return {};
  }
  addTxes(ctx, txes, doClone, requiredTxes) {
    const created = [];
    const orphans = [];
    const skipped = /* @__PURE__ */ new Map();
    for (const tx of txes) {
      let ownDoc;
      switch (tx._class) {
        case import_component.default.class.TxCreateDoc: {
          const doc = import_tx.TxProcessor.createDoc2Doc(tx, doClone);
          this.objectById.set(doc._id, doc);
          created.push({ doc, tx });
          ownDoc = doc;
          break;
        }
        case import_component.default.class.TxUpdateDoc: {
          const cud = tx;
          const doc = this.ownDoc(cud.objectId);
          if (doc !== void 0) {
            this.updateDoc(cud.objectId, doc, cud);
            import_tx.TxProcessor.updateDoc2Doc(doc, cud);
          } else {
            orphans.push(tx);
          }
          break;
        }
        case import_component.default.class.TxRemoveDoc:
          try {
            this.delDoc(tx.objectId);
          } catch (err) {
            orphans.push(tx);
          }
          break;
        case import_component.default.class.TxMixin: {
          const mix = tx;
          const doc = this.ownDoc(mix.objectId);
          if (doc !== void 0) {
            this.updateDoc(mix.objectId, doc, mix);
            import_tx.TxProcessor.updateMixin4Doc(doc, mix);
          } else {
            orphans.push(tx);
          }
          break;
        }
      }
      try {
        this.hierarchy.tx(tx, ownDoc);
      } catch (err) {
        skipped.set(tx._id, tx);
        ctx.warn("failed to apply model transaction to hierarchy, skipping", {
          _id: tx._id,
          _class: tx._class,
          err
        });
      }
    }
    for (const tx of orphans.splice(0)) {
      switch (tx._class) {
        case import_component.default.class.TxUpdateDoc: {
          const update = tx;
          const doc = this.ownDoc(update.objectId);
          if (doc === void 0) {
            orphans.push(tx);
            break;
          }
          this.updateDoc(update.objectId, doc, update);
          import_tx.TxProcessor.updateDoc2Doc(doc, update);
          try {
            this.hierarchy.tx(tx);
          } catch (err) {
            skipped.set(tx._id, tx);
            ctx.warn("failed to apply model transaction to hierarchy, skipping", {
              _id: tx._id,
              _class: tx._class,
              err
            });
          }
          break;
        }
        case import_component.default.class.TxMixin: {
          const mixin = tx;
          const doc = this.ownDoc(mixin.objectId);
          if (doc === void 0) {
            orphans.push(tx);
            break;
          }
          this.updateDoc(mixin.objectId, doc, mixin);
          import_tx.TxProcessor.updateMixin4Doc(doc, mixin);
          try {
            this.hierarchy.tx(tx);
          } catch (err) {
            skipped.set(tx._id, tx);
            ctx.warn("failed to apply model transaction to hierarchy, skipping", {
              _id: tx._id,
              _class: tx._class,
              err
            });
          }
          break;
        }
        default:
          orphans.push(tx);
      }
    }
    for (const { doc, tx } of created) {
      if (this.objectById.get(doc._id) !== doc) continue;
      try {
        this.indexByClass(doc);
      } catch (err) {
        skipped.set(tx._id, tx);
        ctx.warn("failed to index model document, skipping", { _id: doc._id, _class: doc._class, err });
      }
    }
    if (orphans.length > 0) {
      const byClass = {};
      for (const tx of orphans) {
        skipped.set(tx._id, tx);
        byClass[tx._class] = (byClass[tx._class] ?? 0) + 1;
      }
      ctx.info("skipped model transactions for orphan documents", {
        total: orphans.length,
        byClass
      });
    }
    const skippedRequired = Array.from(skipped.values()).filter((tx) => requiredTxes?.has(tx._id) === true);
    if (skippedRequired.length > 0) {
      throw new Error(`Failed to apply required model transactions: ${skippedRequired.map((tx) => tx._id).join(", ")}`);
    }
  }
  async txUpdateDoc(tx) {
    try {
      const doc = this.ownDoc(tx.objectId);
      this.updateDoc(tx.objectId, doc, tx);
      import_tx.TxProcessor.updateDoc2Doc(doc, tx);
      return tx.retrieve === true ? { object: doc } : {};
    } catch (err) {
    }
    return {};
  }
  async txRemoveDoc(tx) {
    try {
      this.delDoc(tx.objectId);
    } catch (err) {
    }
    return {};
  }
  // TODO: process ancessor mixins
  async txMixin(tx) {
    const doc = this.ownDoc(tx.objectId);
    if (doc === void 0) {
      throw new import_platform.PlatformError(new import_platform.Status(import_platform.Severity.ERROR, import_component.default.status.ObjectNotFound, { _id: tx.objectId }));
    }
    this.updateDoc(tx.objectId, doc, tx);
    import_tx.TxProcessor.updateMixin4Doc(doc, tx);
    return {};
  }
}
//# sourceMappingURL=memdb.js.map
